export default [
  {
    title: 'Backoffice',
    route: 'backoffice-view',
    icon: 'RepeatIcon',
    roles: ['permission.backoffice.view']
  }]